import { Button } from "antd";
import { ButtonProps } from "antd/lib/button";
import styles from "../styles/btn.module.scss";

const LinkButton = (props: ButtonProps) => {
    return (
        <Button {...props} type="link" className={styles.linkBtn}>
            {props.children}
        </Button>
    );
};

export default LinkButton;
